// A single record makes snapshot + outbox writes atomic. Public signout intent
// lives separately so an offline HttpOnly cookie can never restore access.
let database;
export function db() {
  return (database ||= new Promise((resolve, reject) => {
    const r = indexedDB.open("dm-study-v1", 1);
    r.onupgradeneeded = () => r.result.createObjectStore("records");
    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
  }));
}
export async function read(key = "active") {
  const d = await db();
  return new Promise((resolve, reject) => {
    const r = d.transaction("records").objectStore("records").get(key);
    r.onsuccess = () => resolve(r.result ?? null);
    r.onerror = () => reject(r.error);
  });
}
export async function update(change, { guard, signedOut } = {}) {
  const d = await db();
  return new Promise((resolve, reject) => {
    const t = d.transaction("records", "readwrite"),
      s = t.objectStore("records");
    let value;
    const r = s.get("active");
    r.onsuccess = () => {
      try {
        // Login clears the signed-out flag in the same transaction as its
        // snapshot. A superseded account operation must make no writes.
        if (guard && !guard()) {
          value = null;
          return;
        }
        value = change(r.result ?? null);
        if (value === null) s.delete("active");
        else s.put(value, "active");
        if (signedOut !== undefined) s.put(signedOut, "signedOut");
      } catch (e) {
        t.abort();
        reject(e);
      }
    };
    t.oncomplete = () => resolve(value);
    t.onerror = () => reject(t.error);
    t.onabort = () => reject(t.error || new Error("Storage write cancelled"));
  });
}
// Check and removal share a readwrite transaction: another tab cannot insert
// an event between a stale zero-count check and destructive deletion.
export async function clearPrivate(discard = false) {
  const d = await db();
  return new Promise((resolve, reject) => {
    const t = d.transaction("records", "readwrite");
    const s = t.objectStore("records");
    let failure;
    const request = s.get("active");
    request.onsuccess = () => {
      if (!discard && pendingCount(request.result)) {
        failure = Object.assign(
          new Error("Unsynced work needs discard consent"),
          { code: "UNSYNCED" },
        );
        t.abort();
        return;
      }
      s.delete("active");
      s.put(true, "signedOut");
    };
    t.oncomplete = resolve;
    t.onerror = () => reject(failure || t.error);
    t.onabort = () =>
      reject(failure || t.error || new Error("Storage removal cancelled"));
  });
}
export const pendingCount = (local) =>
  local
    ? local.pending.length + local.additions.length + (local.settings ? 1 : 0) + (local.pendingChallengeAttempts?.length || 0)
    : 0;
